import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ContentCategoryModel,
  CuratedCardModel,
  CuratedContentParams,
  FeaturedCardModel,
  FeaturedCarouselParams,
} from 'src/app/media-app/models/featured-card.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeaturedService {
  private apiEndPoint = environment.apiBaseUrl + 'api/featured';

  constructor(private http: HttpClient) {}

  getCarousel(params: FeaturedCarouselParams = {}): Observable<FeaturedCardModel[]> {
    let queryParams = new HttpParams();

    if (params.category) {
      queryParams = queryParams.set('category', params.category);
    }

    if (params.limit) {
      queryParams = queryParams.set('limit', params.limit.toString());
    }

    if (params.industry) {
      queryParams = queryParams.set('industry', params.industry);
    }

    return this.http.get<FeaturedCardModel[]>(`${this.apiEndPoint}/carousel`, {
      params: queryParams,
    });
  }

  getCategories(): Observable<ContentCategoryModel[]> {
    return this.http.get<ContentCategoryModel[]>(`${this.apiEndPoint}/categories`);
  }

  getCurated(params: CuratedContentParams = {}): Observable<CuratedCardModel[]> {
    let queryParams = new HttpParams();

    if (params.type) {
      queryParams = queryParams.set('type', params.type);
    }

    if (params.category) {
      queryParams = queryParams.set('category', params.category);
    }

    if (params.industry) {
      queryParams = queryParams.set('industry', params.industry);
    }

    return this.http.get<CuratedCardModel[]>(`${this.apiEndPoint}/curated`, {
      params: queryParams,
    });
  }

  getStarterLayout(mediaAppId: number): Observable<{ layoutId: number; bannerText: string }> {
    return this.http.get<{ layoutId: number; bannerText: string }>(
      `${this.apiEndPoint}/starter-layout`,
      {
        params: { media_app_id: mediaAppId },
      }
    );
  }
}
